import React, { useMemo, useState, useCallback, useEffect } from "react";


export const MainContext = React.createContext(false);

export const MainProvider = ({ children }) => {

  const [isLogin, setIsLogin] = useState(false)
  const [visible, setVisible] = useState(false)
  const [authData, setAuthData] = useState({name:''})
  const [authLiff, setAuthLiff] = useState(null)


  const sleep = (delay) => {
      return new Promise((resolve) => setTimeout(resolve, delay));
  }

  return (
    <MainContext.Provider value={{ authLiff, setAuthLiff, sleep, visible, setVisible, isLogin, setIsLogin, authData, setAuthData }}>
      { children }
    </MainContext.Provider>
  );
};